import { I18nFragment } from '@diagentech/exprworks-ui-components';
import Link from '@mui/material/Link';
import React, { useCallback } from 'react';

import { useAppDispatch } from '@/App/hooks';
import { CONSULTATIONS_DIALOG_ID } from '@/components/consultations/ConsultationsDialog';
import { setShowConsultations } from '@/features/ui/uiSlice';

export const ConsultationsLink: React.FC = () => {
  const dispatch = useAppDispatch();

  const showConsultations = useCallback(() => {
    dispatch(setShowConsultations(true));
  }, [dispatch]);

  return (
    <Link
      variant="body2"
      component="button"
      aria-controls={CONSULTATIONS_DIALOG_ID}
      aria-haspopup="true"
      onClick={showConsultations}
    >
      <I18nFragment id="SH.BTN.CONSULTATIONS" />
    </Link>
  );
};
